import { axios } from '@/utils/request'

const PROJECT_ITEM_FIRST_API = '/project/first'
const PROJECT_ITEM_SECOND_API = '/project/second'

export function getProjectFirstItemDetail (id) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/detail?id=' + id,
    method: 'get'
  })
}
export function getProjectSecondItemDetail (id) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/detail?id=' + id,
    method: 'get'
  })
}
export function createProjectFirstItem (data) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/create',
    method: 'post',
    data: data
  })
}
export function createProjectSecondItem (data) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/create',
    method: 'post',
    data: data
  })
}

export function updateProjectFirstItem (data) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/update',
    method: 'post',
    data: data
  })
}

export function updateProjectSecondItem (data) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/update',
    method: 'post',
    data: data
  })
}

export function deleteProjectFirstItem (id) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/delete?id=' + id,
    method: 'post'
  })
}
export function deleteProjectSecondItem (id) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/delete?id=' + id,
    method: 'post'
  })
}
export function getProjectFirstItemPage (data) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/page',
    method: 'post',
    params: data
  })
}
export function getProjectSecondItemPage (data) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/page',
    method: 'post',
    params: data
  })
}
export function disableProjectSecondItem (id) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/disable?id=' + id,
    method: 'post'
  })
}
export function getProjectFirstItemStatistics (data) {
  return axios({
    url: PROJECT_ITEM_FIRST_API + '/statistics',
    method: 'post',
    data: data
  })
}
export function getTerminalHistory (data) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/historyPage?code=' + data.code + '&pageNumber=' + data.pageNumber + '&pageSize=' + data.pageSize + '&keyword=' + data.keyword,
    method: 'post'
  })
}

export function exportHistory (data) {
  return axios({
    url: PROJECT_ITEM_SECOND_API + '/exportHistory?code=' + data.code,
    method: 'post',
    responseType: 'blob'
  })
}
